import React, { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Translate } from "../../Enums/Tranlate";
import AdminService from "../../../services/AdminService";
import { useNavigate } from "react-router-dom";
import pin from "../../../images/icons/pin.svg";
import totalAdmins from "../../../images/icons/total-admins.svg";
import packages from "../../../images/icons/packages.svg";
import booking from "../../../images/icons/booking.svg";
import productsImg from "../../../images/icons/products.svg";
import matches from "../../../images/icons/matches.svg";
import category from "../../../images/icons/category.svg";
import users from "../../../images/icons/users.svg";
import "./style.scss";

const Dashboard = () => {
	const [formData, setFormData] = useState({
		user: "",
		category: "",
		product: "",
		pack: "",
		pinMark: "",
		publicMatch: "",
		privateMatch: "",
		tournamentMatch: "",
		booking: "",
		totalAdmins: "",
	});
	const [loading, setLoading] = useState(false);
	const lang = useSelector((state) => state.auth.lang);
	const navigate = useNavigate();

	useEffect(() => {
		setLoading(true);
		new AdminService()
			.getDashboard()
			.then((res) => {
				if (res?.status) {
					setFormData(res.data.data);
				}
				setLoading(false);
			})
			.catch(() => setLoading(false));
	}, []);

	if (loading) {
		return (
			<Row>
				{Object.entries(formData)?.map((_, index) => {
					return (
						<Col className="col-md-4 col-sm-6" key={index}>
							<Card style={{ height: "128.75px" }}>
								<Card.Body>
									<div className="skeleton-loader">
										<div className="loader-header"></div>
										<div className="loader-content"></div>
									</div>
								</Card.Body>
							</Card>
						</Col>
					);
				})}
			</Row>
		);
	}

	return (
		<div className="dashboard">
			<div className="dashboard-info">
				<div className="row">
					{/* Admins */}
					<div className="col-md-3 mb-3 col-6">
						<div className="card" onClick={() => navigate("/admins")}>
							<img src={totalAdmins} alt="dollar" width={40} className="mb-2" />

							<span className="fs-16">{formData?.admins}</span>
							<h2 className="fs-14 my-2">{Translate[lang].admins}</h2>
						</div>
					</div>
					{/* Users */}
					<div className="col-md-3 mb-3 col-6">
						<div className="card" onClick={() => navigate("/users")}>
							<img src={users} alt="dollar" width={40} className="mb-2" />

							<span className="fs-16">{formData?.users}</span>
							<h2 className="fs-14 my-2">{Translate[lang].users}</h2>
						</div>
					</div>
					{/* Vendors */}
					<div className="col-md-3 mb-3 col-6">
						<div className="card" onClick={() => navigate("/vendors")}>
							<img src={users} alt="dollar" width={40} className="mb-2" />

							<span className="fs-16">{formData?.vendors}</span>
							<h2 className="fs-14 my-2">{Translate[lang].vendors}</h2>
						</div>
					</div>
					{/* Categories */}
					<div className="col-md-3 mb-3 col-6">
						<div className="card" onClick={() => navigate("/")}>
							<img src={category} alt="dollar" width={40} className="mb-2" />

							<span className="fs-16">{formData?.categories}</span>
							<h2 className="fs-14 my-2">{Translate[lang].total_categories}</h2>
						</div>
					</div>
					{/* Packages */}
					<div className="col-md-3 mb-3 col-6">
						<div className="card" onClick={() => navigate("/packages")}>
							<img src={packages} alt="dollar" width={40} className="mb-2" />

							<span className="fs-16">{formData?.packages}</span>
							<h2 className="fs-14 my-2">{Translate[lang].total_packages}</h2>
						</div>
					</div>
					{/* orders */}
					<div className="col-md-3 mb-3 col-6">
						<div className="card">
							{/* <img src={matches} alt="dollar" width={40} className="mb-2" /> */}
							<i className="mb-2 la la-truck" style={{ fontSize: "32px" }} />

							<span className="fs-16">{formData?.orders}</span>
							<h2 className="fs-14 my-2">{Translate[lang].orders}</h2>
						</div>
					</div>
					{/* Delivered */}
					<div className="col-md-3 mb-3 col-6">
						<div className="card">
							{/* <img src={matches} alt="dollar" width={40} className="mb-2" /> */}
							<i
								className="mb-2 la la-truck text-primary"
								style={{ fontSize: "32px" }}
							/>

							<span className="fs-16">{formData?.ordersDelivered}</span>
							<h2 className="fs-14 my-2">
								{Translate[lang].orders} ({Translate[lang].delivered})
							</h2>
						</div>
					</div>
					{/* OnTheWay */}
					<div className="col-md-3 mb-3 col-6">
						<div className="card">
							{/* <img src={matches} alt="dollar" width={40} className="mb-2" /> */}
							<i
								className="mb-2 la la-truck text-success"
								style={{ fontSize: "32px" }}
							/>

							<span className="fs-16">{formData?.ordersOnTheWay}</span>
							<h2 className="fs-14 my-2">
								{Translate[lang].orders} ({Translate[lang].on_the_way})
							</h2>
						</div>
					</div>
					{/* Pending */}
					<div className="col-md-3 mb-3 col-6">
						<div className="card">
							{/* <img src={matches} alt="dollar" width={40} className="mb-2" /> */}
							<i className="mb-2 la la-truck" style={{ fontSize: "32px" }} />

							<span className="fs-16">{formData?.ordersPending}</span>
							<h2 className="fs-14 my-2">
								{Translate[lang].orders} ({Translate[lang].pending})
							</h2>
						</div>
					</div>
					{/* Processing */}
					<div className="col-md-3 mb-3 col-6">
						<div className="card">
							{/* <img src={matches} alt="dollar" width={40} className="mb-2" /> */}
							<i className="mb-2 la la-truck" style={{ fontSize: "32px" }} />

							<span className="fs-16">{formData?.ordersProcessing}</span>
							<h2 className="fs-14 my-2">
								{Translate[lang].orders} ({Translate[lang].processing})
							</h2>
						</div>
					</div>
					{/* Unpaid */}
					<div className="col-md-3 mb-3 col-6">
						<div className="card">
							{/* <img src={matches} alt="dollar" width={40} className="mb-2" /> */}
							<i className="mb-2 la la-truck" style={{ fontSize: "32px" }} />

							<span className="fs-16">{formData?.ordersUnpaid}</span>
							<h2 className="fs-14 my-2">
								{Translate[lang].orders} ({Translate[lang].unpaid})
							</h2>
						</div>
					</div>
					{/* Cancelled */}
					<div className="col-md-3 mb-3 col-6">
						<div className="card">
							{/* <img src={matches} alt="dollar" width={40} className="mb-2" /> */}
							<i
								className="mb-2 la la-truck text-danger"
								style={{ fontSize: "32px" }}
							/>

							<span className="fs-16">{formData?.ordersCancelled}</span>
							<h2 className="fs-14 my-2">
								{Translate[lang].orders} ({Translate[lang].cancelled})
							</h2>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Dashboard;
